'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _DeforestationRiskSectorIconRow = require('./DeforestationRiskSectorIconRow.css');

var _DeforestationRiskSectorIconRow2 = _interopRequireDefault(_DeforestationRiskSectorIconRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeforestationRiskSectorIconRow = (_dec = (0, _reactCssModules2.default)(_DeforestationRiskSectorIconRow2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DeforestationRiskSectorIconRow, _Component);

  function DeforestationRiskSectorIconRow() {
    (0, _classCallCheck3.default)(this, DeforestationRiskSectorIconRow);
    return (0, _possibleConstructorReturn3.default)(this, (DeforestationRiskSectorIconRow.__proto__ || (0, _getPrototypeOf2.default)(DeforestationRiskSectorIconRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(DeforestationRiskSectorIconRow, [{
    key: 'render',
    value: function render() {
      var poIcon = require('../../../static/images/icn-po-w.svg');
      var ppIcon = require('../../../static/images/icn-pp-w.svg');
      var rbIcon = require('../../../static/images/icn-rb-w.svg');
      var tbIcon = require('../../../static/images/icn-tb-w.svg');
      var bfIcon = require('../../../static/images/icn-bf-w.svg');
      var syIcon = require('../../../static/images/icn-sy-w.svg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'sector-icons' },
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          null,
          [['Palm oil', poIcon], ['Paper/pulp', ppIcon], ['Rubber', rbIcon], ['Timber', tbIcon], ['Cattle', bfIcon], ['Soy', syIcon]].map(function (e, i) {
            return _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { styleName: 'sector-icons__col', xs: 4, sm: 2 },
              e[0],
              _react2.default.createElement('img', {
                styleName: 'sector-icons__img',
                alt: e[0],
                src: e[1]
              })
            );
          })
        )
      );
    }
  }]);
  return DeforestationRiskSectorIconRow;
}(_react.Component)) || _class);
exports.default = DeforestationRiskSectorIconRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeforestationRiskSectorIconRow/DeforestationRiskSectorIconRow.js
// module id = 1317
// module chunks = 0